import { build_case_agreement_rows } from './my_queue_detail_agreement_helpers';
import {
  build_detail_tabs,
  document_answer_meta,
  is_document_question,
  section_tone
} from './my_queue_detail_document_helpers';

export const myQueueDetailMethods = {
  build_case_agreement_rows(caseItem = {}) {
    return build_case_agreement_rows(caseItem);
  },
  build_detail_tabs(case_form_sections = [], agreement_rows = []) {
    return build_detail_tabs(case_form_sections, agreement_rows);
  },
  set_detail_tab(tab_id) {
    this.active_detail_tab = tab_id;
    this.$nextTick(() => {
      this.scroll_active_detail_tab_into_view();
      this.update_detail_tab_overflow();
    });
  },
  section_tone(label = '') {
    return section_tone(label);
  },
  detail_tab_tone(tab = {}) {
    if (tab?.id === 'agreements') {
      return 'navy';
    }

    const tone = this.section_tone(tab?.label || tab?.form_name || '');
    return tone;
  },
  scroll_detail_tabs(direction = 'right') {
    const tab_scroller = this.$refs.detailTabsScroller;
    if (!tab_scroller) return;

    const scroll_offset = Math.max(180, Math.round(tab_scroller.clientWidth * 0.6));
    const left = direction === 'left' ? tab_scroller.scrollLeft - scroll_offset : tab_scroller.scrollLeft + scroll_offset;
    tab_scroller.scrollTo({ left, behavior: 'smooth' });
  },
  update_detail_tab_overflow() {
    const tab_scroller = this.$refs.detailTabsScroller;
    if (!tab_scroller) {
      this.detail_tab_overflow = { left: false, right: false };
      return;
    }

    const max_scroll_left = Math.max(0, tab_scroller.scrollWidth - tab_scroller.clientWidth);
    this.detail_tab_overflow = {
      left: tab_scroller.scrollLeft > 8,
      right: tab_scroller.scrollLeft < max_scroll_left - 8
    };
  },
  scroll_active_detail_tab_into_view() {
    const tab_scroller = this.$refs.detailTabsScroller;
    const active_tab = tab_scroller?.querySelector?.(`[data-detail-tab-id="${this.active_detail_tab}"]`);
    if (!tab_scroller || !active_tab) return;

    active_tab.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'center'
    });
  },
  is_document_question(question = {}) {
    return is_document_question(question);
  },
  document_answer_meta(question = {}) {
    return document_answer_meta(question);
  },
  document_status_meta(question = {}) {
    const document_meta = this.document_answer_meta(question);
    if (document_meta.uploaded) {
      return {
        label: 'OK',
        pill_class: 'bg-success-subtle text-success-emphasis',
        icon_class: 'onboarding-document-status-icon is-success',
        icon: 'bi-check-lg'
      };
    }

    return {
      label: 'Missing',
      pill_class: 'bg-danger-subtle text-danger-emphasis',
      icon_class: 'onboarding-document-status-icon is-danger',
      icon: 'bi-x-lg'
    };
  }
};

